export default __webpack_public_path__ + "static/media/testimonial_logo_2.8eed3802.svg";